module.exports = __webpack_public_path__ + "static/img/map-beijing.85123d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/contact/map-beijing.png
// module id = 90
// module chunks = 1